import { render } from "./detail.vue?vue&type=template&id=5a275288&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "@/assets/css/new.scss?vue&type=style&index=0&lang=scss"
import "./detail.vue?vue&type=style&index=1&id=5a275288&lang=scss"
import "./detail.vue?vue&type=style&index=2&id=5a275288&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a275288"]])

export default __exports__